var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM12 22.125C6.43594 22.125 1.875 17.6203 1.875 12C1.875 6.43594 6.37969 1.875 12 1.875C17.5641 1.875 22.125 6.37969 22.125 12C22.125 17.5641 17.6203 22.125 12 22.125ZM16.4437 8.75156L13.1953 12L16.4437 15.2484C16.6641 15.4687 16.6641 15.825 16.4437 16.0453L16.0453 16.4437C15.825 16.6641 15.4687 16.6641 15.2484 16.4437L12 13.1953L8.75156 16.4437C8.53125 16.6641 8.175 16.6641 7.95469 16.4437L7.55625 16.0453C7.33594 15.825 7.33594 15.4687 7.55625 15.2484L10.8047 12L7.55625 8.75156C7.33594 8.53125 7.33594 8.175 7.55625 7.95469L7.95469 7.55625C8.175 7.33594 8.53125 7.33594 8.75156 7.55625L12 10.8047L15.2484 7.55625C15.4687 7.33594 15.825 7.33594 16.0453 7.55625L16.4437 7.95469C16.6594 8.175 16.6594 8.53125 16.4437 8.75156Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconDark);
export default __webpack_public_path__ + "static/media/CloseIconDark.c0510378.svg";
export { ForwardRef as ReactComponent };